import styled from "@emotion/styled";
import { Container, Row, Col } from "components/layout";
import mixins from "theme/mixins";

export const StyledFooter = styled(Container)`
  ${mixins.fontCoda()};
  color: ${(props) => props.theme.white};
  font-size: 12px;
  letter-spacing: 0.05em;
  text-align: center;

  background-color: ${(props) => props.theme.darkBlue};

  min-height: 60px;

  padding-left: 30px;
  padding-right: 30px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  text-transform: uppercase;

  a {
    color: ${(props) => props.theme.white};

    &:hover {
      color: ${(props) => props.theme.white};
    }
  }
`;

export const StyledInnerContainer = styled(Container)``;

export const StyledContainerRow = styled(Row)`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledLeftCol = styled(Col)`
  display: flex;
  justify-content: left;
`;

export const StyledRightCol = styled(Col)`
  display: flex;
  justify-content: right;
`;

export const Logo = styled.img`
  height: 20px;
  filter: brightness(0) invert(1);
`;
